import { Button, Icon, Typography } from '@material-ui/core';
import { fetchConnectedAccountDetails } from 'actions/financial';
import React from 'react';
import Loader from 'react-overlay-loader/lib/Loader';
import { connect } from 'react-redux';
import { callAPI } from 'utils/network';
import {
  CreateConnectedAccountAPIRequest,
  CreateConnectedAccountLinkAPIRequest,
} from '../../../../../utils/constants/network';
import './index.scss';

class MenusPanel extends React.Component {
  state = {
    creatingAccountLink: false,
  };

  // Lifecycle

  componentDidMount() {
    this.props.fetchConnectedAccountDetails();

    if (this.props.stripeToken) {
      window.Intercom('trackEvent', 'connected-stripe-account');
    }
  }

  render() {
    const { stripeToken, fetchingConnectedAccount, connectedAccount } =
      this.props;
    const { creatingAccountLink } = this.state;

    const createConnectedAccount = async updateAccount => {
      this.setState({ creatingAccountLink: true });
      const req = new CreateConnectedAccountAPIRequest({});
      try {
        const data = await callAPI(req);
        window.location.href = data.link_url;
      } catch (err) {
        console.error(err);
      }

      this.setState({ creatingAccountLink: false });
    };

    const generateAccountLink = async updateAccount => {
      this.setState({ creatingAccountLink: true });

      const req = new CreateConnectedAccountLinkAPIRequest({
        link_type: updateAccount ? 'account_update' : 'account_onboarding',
      });

      try {
        const data = await callAPI(req);
        window.location.href = data.link_url;
      } catch (err) {
        console.error(err);
      }

      this.setState({ creatingAccountLink: false });
    };

    const renderNoStripeToken = () => (
      <React.Fragment>
        <div className="financial__container__left">
          <div className="financial__heading">
            <Typography variant="headline" className="financial__headline">
              Let's get started
            </Typography>
          </div>
          <Typography variant="subheading" className="financial__description">
            Tabb partners with Stripe to handle payments securely and to pay
            money directly into your bank account. To get started, you just need
            to share a few details about your business with Stripe.
          </Typography>
        </div>

        <div className="financial__container__right">
          <Button
            onClick={() => createConnectedAccount(false)}
            className="fatsoma__cta financial__cta__btn"
            color="primary"
            variant="outlined"
          >
            Get Started with Stripe
          </Button>
        </div>
      </React.Fragment>
    );

    const renderAccountStatus = () => {
      const acc = connectedAccount.account || {};
      const req = acc.requirements || {
        currently_due: [],
        disabled_reason: '',
        errors: [],
      };
      const payoutsEnabled = acc.payouts_enabled;

      const accountGoodStanding =
        payoutsEnabled &&
        req.currently_due.length === 0 &&
        (req.disabled_reason === '' || req.disabled_reason == null) &&
        req.errors.length === 0;

      const pendingVerification =
        req.disabled_reason === 'requirements.pending_verification';

      let createUpdateLink = true;
      if (!acc.details_submitted || req.currently_due.length > 0) {
        createUpdateLink = false;
      } else {
        createUpdateLink = true;
      }

      const renderStatusIcon = () => {
        if (accountGoodStanding) {
          return (
            <Icon className="status__icon status__icon__success">
              check_circle
            </Icon>
          );
        }

        if (pendingVerification) {
          return (
            <Icon className="status__icon status__icon__warning">
              hourglass_full
            </Icon>
          );
        }

        if (!acc.details_submitted) {
          return (
            <Icon className="status__icon status__icon__danger">error</Icon>
          );
        }
      };

      const renderStatusText = () => {
        if (!payoutsEnabled || !acc.details_submitted) {
          return 'You cannot receive payouts';
        }

        if (accountGoodStanding) {
          return 'Everything Looks Good';
        } else if (pendingVerification) {
          return 'Verifying Information';
        } else {
          return 'Action is Required';
        }
      };

      const renderDetailsText = () => {
        if (accountGoodStanding) {
          return 'Your details are currently up-to-date on Stripe and no further action is required at this time.';
        }

        if (!acc.details_submitted) {
          return 'You must submit your business information to Stripe to enable payouts.';
        }

        if (pendingVerification) {
          return 'Stripe are verifying your details. Check back later to see any updates.';
        }

        if (req.errors.length !== 0) {
          return 'There were errors with your verification - please update your details on Stripe';
        }

        if (req.disabled_reason != null && req.disabled_reason !== '') {
          return 'Your account has been disabled by Stripe - please update your details.';
        }
      };

      return (
        <React.Fragment>
          <div className="financial__container__left">
            <div className="financial__heading">
              <Typography variant="headline" className="financial__headline">
                {renderStatusText()}
              </Typography>
              {renderStatusIcon()}
            </div>
            <Typography variant="subheading" className="financial__description">
              {renderDetailsText()}
            </Typography>
          </div>

          <div className="financial__container__right">
            <Button
              onClick={() => generateAccountLink(createUpdateLink)}
              className="fatsoma__cta financial__cta__btn"
              color="primary"
              variant="outlined"
            >
              Update Details
            </Button>
          </div>
        </React.Fragment>
      );
    };

    return (
      <div className="financial__wrapper">
        <h1 className="financial__title">Your Financial Account</h1>

        <div className="financial__container">
          {/* <Paper className="panel__paper"> */}
          <Loader loading={creatingAccountLink || fetchingConnectedAccount} />
          {!stripeToken && renderNoStripeToken()}
          {connectedAccount && renderAccountStatus()}
          {/* </Paper> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  stripeToken: state.venue.stripe_token,
  fetchingConnectedAccount: state.financial.fetchingConnectedAccount,
  connectedAccount: state.financial.connectedAccount,
  connectedAccountError: state.financial.connectedAccountError,
});

const mapDispatchToProps = dispatch => ({
  fetchConnectedAccountDetails: () => dispatch(fetchConnectedAccountDetails()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MenusPanel);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Financial/ConnectAccountPanel/index.jsx